import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import BaseSideNav from '@/components/v2/BaseSideNav.vue';
import { Component } from 'vue-property-decorator';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import { OVERVIEW_ROUTE, PRODUCTS_ROUTE, CATEGORIES_ROUTE, INQUIRIES_ROUTE, BROADCAST_ROUTE, BROADCAST_ROUTE_FB, BROADCAST_ROUTE_SMS, CUSTOMER_SEGMENT_ROUTE, } from '@/helpers/constants/InquiryRoutes';
let InquiryBundle = class InquiryBundle extends mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.toggleProductsMenu = false;
        this.toggleBroadcastMenu = false;
        /**
         * Route Key attribute
         * This is the key to trigger menu reactivity, We set this as BaseSideNav
         *  component key
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @since Version {0.16.0}
         */
        this.routeKey = '';
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    productMenu(productUuid) {
        const params = {
            appUUID: this.appUuid,
            componentUUID: productUuid,
        };
        return {
            icon_path: require('./assets/campaign.svg'),
            text: 'Products',
            model: this.toggleProductsMenu,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: PRODUCTS_ROUTE.title,
                    path: {
                        name: PRODUCTS_ROUTE.name,
                        params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: CATEGORIES_ROUTE.title,
                    path: {
                        name: CATEGORIES_ROUTE.name,
                        params,
                    },
                    exact: false,
                },
            ],
        };
    }
    /**
     * Default Menu Items Builder
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.18
     *
     * @returns {Menu[]} list of menu items
     */
    buildDefaultMenu(params) {
        return [
            {
                icon_path: require('./assets/inquiries.svg'),
                text: INQUIRIES_ROUTE.title,
                path: {
                    name: INQUIRIES_ROUTE.name,
                    params,
                },
                exact: true,
            },
            this.broadcastMenu(params),
            {
                icon_path: require('./assets/customer-segment.svg'),
                text: CUSTOMER_SEGMENT_ROUTE.title,
                path: {
                    name: CUSTOMER_SEGMENT_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/notification.svg'),
                text: 'Notification Manager',
                path: {
                    name: 'inquiry-notifications',
                    params,
                },
                exact: false,
            },
        ];
    }
    broadcastMenu(params) {
        return {
            icon_path: require('./assets/broadcast-orange.svg'),
            text: BROADCAST_ROUTE.title,
            model: this.toggleBroadcastMenu,
            children: this.buildBroadcastMenu(params),
        };
    }
    buildMenuFB(params) {
        return {
            icon: this.childrenMenuIcon,
            text: BROADCAST_ROUTE_FB.title,
            path: {
                name: BROADCAST_ROUTE_FB.name,
                params,
            },
            exact: true,
        };
    }
    buildMenuSMS(params) {
        return {
            icon: this.childrenMenuIcon,
            text: BROADCAST_ROUTE_SMS.title,
            path: {
                name: BROADCAST_ROUTE_SMS.name,
                params,
            },
            exact: true,
        };
    }
    buildBroadcastMenu(params) {
        const defaultMenu = [this.buildMenuFB(params)];
        if (this.kioskTracker) {
            return [...defaultMenu, this.buildMenuSMS(params)];
        }
        return defaultMenu;
    }
    get menuItems() {
        const params = {
            appUUID: this.appUuid,
        };
        let items = [];
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            const { productComponent } = this.appDetails;
            items = [
                this.productMenu(productComponent.uuid),
                ...this.buildDefaultMenu({ ...params, componentUUID: productComponent.uuid }),
            ];
        }
        const menuItems = items.length >= 1 ? items : this.buildDefaultMenu(params);
        return [
            {
                icon_path: require('./assets/overview-orange.svg'),
                text: OVERVIEW_ROUTE.title,
                path: {
                    name: OVERVIEW_ROUTE.name,
                    params,
                },
                exact: false,
            },
            ...menuItems,
        ];
    }
    /**
     * Created Hook Handle for Activating Selected Menu on Reload
     *  Set Products Menu to active when user is on Products/Categories Page
     *  Set Broadcast Menu to active when user is on SMS/FB Broadcast Page
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.16.0}
     */
    created() {
        const { currentRoute } = this.$router;
        const { parentMenu } = currentRoute.meta;
        if (parentMenu === BROADCAST_ROUTE.name) {
            this.toggleBroadcastMenu = true;
            this.toggleProductsMenu = false;
        }
        else if (parentMenu === PRODUCTS_ROUTE.name) {
            this.toggleProductsMenu = true;
            this.toggleBroadcastMenu = false;
        }
    }
};
InquiryBundle = __decorate([
    Component({
        components: {
            BaseSideNav,
        },
    })
], InquiryBundle);
export default InquiryBundle;
